import React from "react";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import { SftpBadge } from "./capacidadeBadges";
import { drawerEmptyStyle, drawerFieldRowStyle, drawerFieldLabelStyle } from "./detalheDrawer.styles";

// Aba "SFTP" do drawer (H5, PO1-2620). Consome o bloco `sftp` já embutido na
// resposta de GET /transportadoras/:id/capacidades (H4) — sem endpoint
// dedicado. Sempre visível, mesmo sem FLOW: o gate de feature está só na
// copy (gancho comercial), nunca escondendo a aba (decisão do kickoff).
export default function SftpTab({ sftp }) {
  if (!sftp) {
    return <div style={drawerEmptyStyle}>Sem dados de SFTP para esta transportadora.</div>;
  }

  const { cte, fatura, embarcadorTemFlow } = sftp;

  return (
    <div>
      <div
        style={{
          padding: "0.75rem 0.9rem",
          borderRadius: 10,
          marginBottom: "0.9rem",
          background: embarcadorTemFlow ? AUTOPILOT_COLORS.statusSuccessBg : AUTOPILOT_COLORS.insetSurface,
          border: `1px solid ${embarcadorTemFlow ? AUTOPILOT_COLORS.statusSuccessBorder : AUTOPILOT_COLORS.border}`,
          color: embarcadorTemFlow ? AUTOPILOT_COLORS.statusSuccess : AUTOPILOT_COLORS.text,
          fontSize: "0.82rem",
          lineHeight: 1.5,
        }}
      >
        {embarcadorTemFlow
          ? "Monitorado pela Auditoria de Frete — os arquivos de CT-e e Fatura recebidos por SFTP alimentam a conferência automática."
          : "Habilite a auditoria automática de frete e passe a receber CT-e e Fatura direto por SFTP, sem depender de digitação manual. Fale com o time comercial da Everlog."}
      </div>

      <div style={drawerFieldRowStyle}>
        <span style={drawerFieldLabelStyle}>CT-e por SFTP</span>
        <SftpBadge {...cte} embarcadorTemFlow={embarcadorTemFlow} />
      </div>
      <div style={drawerFieldRowStyle}>
        <span style={drawerFieldLabelStyle}>Fatura por SFTP</span>
        <SftpBadge {...fatura} embarcadorTemFlow={embarcadorTemFlow} />
      </div>
      {(cte?.diasSemArquivo !== null && cte?.diasSemArquivo !== undefined) && (
        <div style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.72rem", marginTop: "0.5rem" }}>
          Último CT-e recebido há {cte.diasSemArquivo} dia{cte.diasSemArquivo === 1 ? "" : "s"}.
        </div>
      )}
    </div>
  );
}
